var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',_vm._g({class:[
             _vm.settings.sub2class, _vm.settings.sub2class + _vm.parentModel.category,
             _vm.item.position ? _vm.settings.sub2class + _vm.item.position : '',
             {'c-tile-nav__tile-sub2--active': _vm.isActive()},
             {'c-tile-nav__tile-sub2--inactive': !_vm.isActive()}
         ],attrs:{"href":'/beispiel/' + _vm.getInstanceURI(this.item['instances'][0]),"data-color":_vm.parentModel.color,"data-dir":"--right","data-title":_vm.item.title},on:{"click":function($event){$event.preventDefault();return _vm.setActive($event)}}},{mouseenter: _vm.showTooltip, mouseleave: _vm.hideTooltip, mousemove: _vm.moveMouse }),[_c('span',{staticClass:"c-tile-nav__hidden-link"},[_vm._v(_vm._s(_vm.item.title))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ff2b5c0","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./source/vuejs/components/NavTask.vue
// module id = 378
// module chunks = 0